module.exports = __webpack_public_path__ + "static/media/Birds.d53cb135.png";